import React, { useState } from 'react';
import { CountdownTimer } from '../components/CountdownTimer';
import { PricingSelector } from '../components/PricingSelector';
const testimonials = [{
  initials: 'CR',
  name: 'Carolina R.',
  location: 'Mendoza',
  product: 'Kit + Lashista de Élite',
  quote: 'El módulo de postura me cambió la vida. Tenía dolor de cuello desde hace 8 meses y lo atribuía al trabajo normal. En 3 días de aplicar la Regla de los 90 grados el dolor bajó un 80%. Ojalá lo hubiera tenido antes.'
}, {
  initials: 'RM',
  name: 'Rocío M.',
  location: 'Buenos Aires',
  product: 'Kit Agenda Profesional',
  quote: 'La parte del Checklist de Clienta de Riesgo vale todo el precio del Kit. Evité a dos canceladoras en una semana solo leyendo las señales que nunca había sabido identificar. El sistema funciona.'
}, {
  initials: 'SC',
  name: 'Sabrina C.',
  location: 'La Plata',
  product: 'Kit + Lashista de Élite',
  quote: 'El módulo de velocidad me permitió meter una clienta más por día. Eso es plata extra por día sin buscar más clientas ni trabajar más horas. En un mes pagué el Kit varias veces.'
}, {
  initials: 'PA',
  name: 'Paula A.',
  location: 'Neuquén',
  product: 'Kit Agenda Profesional',
  quote: 'Los 25 mensajes del Bono 2 son un antes y un después. Antes improvisaba y siempre cedía. Ahora copio el mensaje, lo mando y la conversación cierra sola. Sin culpa, sin drama, sin perder la seña.'
}];
const faqs = [{
  q: '¿Sirve si recién estoy empezando como lashista?',
  a: 'Sí. De hecho es el mejor momento para empezar con el sistema correcto. Las lashistas que instalan políticas desde el inicio nunca tienen que "reprogramar" la cabeza de sus clientas. Empezás con las reglas claras y nunca conocen otra versión tuya.'
}, {
  q: '¿Cómo recibo el material?',
  a: '100% digital. Acceso inmediato por email en menos de 5 minutos después de confirmar el pago. Formato PDF optimizado para leer en el celular, tablet o computadora. Sin links que vencen. Sin plataformas complicadas. El material es tuyo para siempre.'
}, {
  q: '¿Lo puedo implementar si tengo la agenda llena y poco tiempo?',
  a: 'Exactamente para eso fue diseñado. El Bono 1 (Kit Express) te da el sistema mínimo funcionando en 10 minutos. Los tomos los implementás de a uno, en el orden que más urgencia tengas. No necesitás leer todo antes de empezar.'
}, {
  q: '¿Tiene garantía real?',
  a: '30 días completos. Sin formularios. Sin justificaciones. Sin drama. Si implementaste honestamente y no sentís que valió la pena: te devolvemos el 100%. Así de simple.'
}, {
  q: '¿Es para lashistas de cualquier nivel?',
  a: 'Sí. El sistema funciona si tenés 5 clientas o 50, 1 año de experiencia o 10, estudio propio o trabajás a domicilio, nunca pusiste una política o ya intentaste sin resultados. El denominador común no es el nivel. Es el problema: las cancelaciones. Si ese problema existe, el sistema funciona.'
}];
const costComparison = [{
  sin: 'Sin sistema de seña instalado',
  costo: 'Turnos confirmados de palabra que se caen sin consecuencia'
}, {
  sin: 'Sin política de cancelación real',
  costo: 'Horas de trabajo perdidas que nadie te devuelve ni te paga'
}, {
  sin: 'Sin filtro de clientas de riesgo',
  costo: 'Canceladoras seriales que entran a tu agenda una y otra vez'
}, {
  sin: 'Sin banco de mensajes',
  costo: 'Improvisación bajo presión que termina en ceder siempre'
}, {
  sin: 'Sin lista de espera activa',
  costo: 'Turno caído igual a ingreso perdido sin opciones de rescate'
}, {
  sin: 'Sin protocolo de postura',
  costo: 'Dolor crónico que puede obligarte a dejar la profesión en 2-3 años'
}, {
  sin: 'Próximo lunes sin sistema',
  costo: 'El mismo ciclo, la misma pérdida, el mismo agotamiento'
}];
function FaqItem({
  q,
  a
}: {
  q: string;
  a: string;
}) {
  const [open, setOpen] = useState(false);
  return <div className="bg-white border border-[#E8D5C4] rounded-2xl overflow-hidden shadow-sm" data-id="element-228">
      <button onClick={() => setOpen(!open)} aria-expanded={open} className="w-full flex items-center justify-between p-4 sm:p-5 md:p-6 text-left font-medium text-sm sm:text-base md:text-lg text-[#2D1A22] hover:text-[#5A2A3D] transition-colors" style={{
      fontFamily: "'DM Serif Display', serif"
    }} data-id="element-229">
        <span data-id="element-230">{q}</span>
        <svg className={`w-4 h-4 sm:w-5 sm:h-5 text-[#B8956A] shrink-0 ml-3 sm:ml-4 transition-transform ${open ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2} data-id="element-231">
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" data-id="element-232" />
        </svg>
      </button>
      <div className={`grid transition-all duration-300 ease-out ${open ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`} data-id="element-233">
        <div className="overflow-hidden" data-id="element-234">
          <div className="px-4 sm:px-5 md:px-6 pb-4 sm:pb-5 md:pb-6 text-[#5A4A4F] leading-relaxed text-xs sm:text-sm md:text-base border-t border-[#E8D5C4]" data-id="element-235">
            <div className="pt-3 sm:pt-4" data-id="element-236">{a}</div>
          </div>
        </div>
      </div>
    </div>;
}
export function TrustSection() {
  return <section className="py-12 md:py-24 bg-white border-t border-[#E8D5C4]" data-id="element-237">
      <div className="max-w-6xl mx-auto px-4" data-id="element-238">
        {/* Testimonials */}
        <div className="text-center mb-7 sm:mb-16" data-id="element-239">
          <div className="text-[10px] tracking-[0.3em] text-[#B8956A] font-bold uppercase mb-3" data-id="element-240">
            Historias reales
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-5xl text-[#2D1A22] leading-tight" data-id="element-241">
            Más lashistas que <span className="italic" data-id="element-242">ya lo tienen</span>
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 gap-3 sm:gap-5 md:gap-6 max-w-4xl mx-auto mb-12 md:mb-28" data-id="element-243">
          {testimonials.map((t, i) => <div key={i} className="bg-[#FAF6F0] border border-[#E8D5C4] rounded-2xl p-4 sm:p-6 md:p-8 hover:border-[#B8956A] hover:-translate-y-0.5 transition-all" data-id="element-244">
              <div className="flex items-center gap-3 mb-3 sm:mb-5" data-id="element-245">
                <div className="w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 rounded-full bg-white text-[#5A2A3D] flex items-center justify-center font-bold text-sm sm:text-base md:text-xl border border-[#E8D5C4] shrink-0" data-id="element-246">
                  {t.initials}
                </div>
                <div className="min-w-0" data-id="element-247">
                  <div className="text-[#B8956A] text-xs tracking-wider mb-0.5" data-id="element-248">
                    ★★★★★
                  </div>
                  <div className="text-[#2D1A22] font-bold text-xs sm:text-sm md:text-base" data-id="element-249">
                    {t.name}{' '}
                    <span className="text-[#5A4A4F] font-normal text-[10px] sm:text-xs md:text-sm ml-0.5" data-id="element-250">
                      📍 {t.location}
                    </span>
                  </div>
                  <div className="text-[10px] sm:text-xs text-[#5A2A3D] font-medium mt-0.5 italic truncate" data-id="element-251">
                    · {t.product}
                  </div>
                </div>
              </div>
              <p className="text-[#5A4A4F] italic text-xs sm:text-sm md:text-base leading-relaxed" data-id="element-252">
                "{t.quote}"
              </p>
            </div>)}
        </div>

        {/* Guarantee */}
        <div className="max-w-3xl mx-auto bg-gradient-to-br from-[#FAF6F0] to-white border border-[#B8956A]/30 rounded-2xl md:rounded-3xl p-6 sm:p-8 md:p-14 text-center mb-12 md:mb-28 relative overflow-hidden shadow-md" data-id="element-253">
          <div className="absolute top-0 left-0 w-full h-1.5 bg-gradient-to-r from-[#B8956A] via-[#C9A97A] to-[#B8956A]" data-id="element-254" />
          <div className="text-5xl sm:text-6xl md:text-7xl mb-4 sm:mb-6" data-id="element-255">
            🛡️
          </div>
          <div className="text-[10px] tracking-[0.3em] text-[#B8956A] font-bold uppercase mb-2 sm:mb-3" data-id="element-256">
            Garantía
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-5xl text-[#2D1A22] mb-4 sm:mb-5 leading-tight" data-id="element-257">
            30 Días <span className="italic" data-id="element-258">Sin Preguntas</span>
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-[#5A4A4F] mb-4 sm:mb-6 leading-relaxed" data-id="element-259">
            Abrís los tomos. Los implementás en tu negocio. Si en 30 días de
            implementación honesta no considerás que vale al menos 10 veces lo
            que pagaste:{' '}
            <strong className="text-[#5A2A3D] italic" data-id="element-260">
              devolución del 100%
            </strong>{' '}
            sin formularios, sin drama, sin explicaciones.
          </p>
          <div className="inline-block bg-white px-4 py-2 sm:px-5 sm:py-2.5 rounded-full text-[#5A2A3D] font-medium border border-[#E8D5C4] text-xs sm:text-sm" data-id="element-261">
            Tasa de devoluciones: menos del 1%.
          </div>
        </div>

        {/* FAQ */}
        <div className="max-w-3xl mx-auto mb-12 md:mb-28" data-id="element-262">
          <div className="text-center mb-7 sm:mb-12" data-id="element-263">
            <div className="text-[10px] tracking-[0.3em] text-[#B8956A] font-bold uppercase mb-3" data-id="element-264">
              FAQ
            </div>
            <h2 className="text-2xl sm:text-3xl md:text-5xl text-[#2D1A22] leading-tight" data-id="element-265">
              Lo que más <span className="italic" data-id="element-266">nos preguntan</span>
            </h2>
          </div>
          <div className="space-y-2.5 sm:space-y-4" data-id="element-267">
            {faqs.map((faq, i) => <FaqItem key={i} q={faq.q} a={faq.a} data-id="element-268" />)}
          </div>
        </div>

        {/* Cost Comparison */}
        <div className="max-w-4xl mx-auto mb-12 md:mb-28" data-id="element-269">
          <h2 className="text-2xl sm:text-3xl md:text-5xl text-[#2D1A22] text-center mb-7 sm:mb-12 leading-tight" data-id="element-270">
            ¿Cuánto cuesta{' '}
            <span className="italic text-[#5A2A3D]" data-id="element-271">no tenerlo</span>?
          </h2>
          <div className="bg-white border border-[#E8D5C4] rounded-2xl md:rounded-3xl overflow-hidden shadow-md" data-id="element-272">
            <div className="overflow-x-auto" data-id="element-273">
              <table className="w-full text-left min-w-[480px]" data-id="element-274">
                <thead data-id="element-275">
                  <tr className="bg-[#FAF6F0]" data-id="element-276">
                    <th className="p-3 sm:p-4 md:p-6 text-[#2D1A22] font-bold text-[10px] sm:text-xs uppercase tracking-wider border-b border-[#E8D5C4] w-1/2" data-id="element-277">
                      Sin Kit Lashista
                    </th>
                    <th className="p-3 sm:p-4 md:p-6 text-[#5A2A3D] font-bold text-[10px] sm:text-xs uppercase tracking-wider border-b border-[#E8D5C4] w-1/2" data-id="element-278">
                      Costo real
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-279">
                  {costComparison.map((row, i) => <tr key={i} className="border-b border-[#E8D5C4] hover:bg-[#FAF6F0]/50 transition-colors" data-id="element-280">
                      <td className="p-3 sm:p-4 md:p-6 text-[#2D1A22] font-medium text-xs sm:text-sm" data-id="element-281">
                        {row.sin}
                      </td>
                      <td className="p-3 sm:p-4 md:p-6 text-[#5A4A4F] text-xs sm:text-sm italic" data-id="element-282">
                        {row.costo}
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Final CTA — uses shared compact PricingSelector */}
        <div className="max-w-4xl mx-auto text-center bg-gradient-to-br from-[#FAF6F0] to-white border border-[#5A2A3D]/20 rounded-2xl md:rounded-3xl p-5 sm:p-6 md:p-10 relative overflow-hidden shadow-xl" data-id="element-283">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-xl h-[300px] rounded-full pointer-events-none" style={{
          background: 'radial-gradient(circle, rgba(184,149,106,0.18) 0%, transparent 70%)'
        }} data-id="element-284" />

          <h2 className="text-3xl sm:text-4xl md:text-6xl text-[#2D1A22] mb-5 sm:mb-6 relative z-10 leading-tight" data-id="element-285">
            El próximo lunes <span className="italic" data-id="element-286">puede ser diferente</span>
            .
          </h2>

          <div className="mb-6 sm:mb-8 relative z-10" data-id="element-287">
            <div className="text-[#5A2A3D] font-bold mb-3 sm:mb-4 uppercase tracking-[0.25em] text-[10px] sm:text-xs" data-id="element-288">
              ⏰ El precio cierra en:
            </div>
            <CountdownTimer data-id="element-289" />
          </div>

          <div className="relative z-10" data-id="element-290">
            <PricingSelector data-id="element-291" />
          </div>
        </div>
      </div>
    </section>;
}